module.exports = __webpack_public_path__ + "static/media/industries-plastic-s.71213f36.webp";